import { hexToRgb } from '@/utils/shellTint'

export type NavIconStyle = {
  bg: string
  fg?: string
}

export type NavSectionKey = 'commercial' | 'partners' | 'customerSuccess' | 'management' | 'financeiro' | 'system'

type SectionTheme = {
  color: string
  activeBgLight: string
  activeBgDark: string
}

/** Uma cor por seção do menu — padrão Rocket Search / Dashboard Agrada */
export const NAV_SECTION_THEMES: Record<NavSectionKey, SectionTheme> = {
  commercial: {
    color: '#3b82f6',
    activeBgLight: 'rgba(59, 130, 246, 0.12)',
    activeBgDark: 'rgba(59, 130, 246, 0.16)',
  },
  partners: {
    color: '#ff2f86',
    activeBgLight: 'rgba(255, 47, 134, 0.12)',
    activeBgDark: 'rgba(255, 47, 134, 0.18)',
  },
  customerSuccess: {
    color: '#8b5cf6',
    activeBgLight: 'rgba(139, 92, 246, 0.12)',
    activeBgDark: 'rgba(139, 92, 246, 0.16)',
  },
  management: {
    color: '#10b981',
    activeBgLight: 'rgba(16, 185, 129, 0.12)',
    activeBgDark: 'rgba(16, 185, 129, 0.16)',
  },
  financeiro: {
    color: '#ef4444',
    activeBgLight: 'rgba(239, 68, 68, 0.12)',
    activeBgDark: 'rgba(239, 68, 68, 0.16)',
  },
  system: {
    color: '#64748b',
    activeBgLight: 'rgba(100, 116, 139, 0.14)',
    activeBgDark: 'rgba(100, 116, 139, 0.2)',
  },
}

export type SectionNavStyles = {
  icon: NavIconStyle
  activeBg: string
  activeBorder: string
}

function mixHex(a: string, b: string, ratio: number): string {
  const c1 = hexToRgb(a)
  const c2 = hexToRgb(b)
  if (!c1 || !c2) return a
  const t = Math.min(1, Math.max(0, ratio))
  const r = Math.round(c1.r * (1 - t) + c2.r * t)
  const g = Math.round(c1.g * (1 - t) + c2.g * t)
  const bCh = Math.round(c1.b * (1 - t) + c2.b * t)
  return '#' + [r, g, bCh].map((v) => v.toString(16).padStart(2, '0')).join('')
}

function toRgba(hex: string, alpha: number): string {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`
}

function adaptIconForDark(color: string): NavIconStyle {
  const darker = mixHex(color, '#0c0d12', 0.32)
  return { bg: toRgba(darker, 0.92), fg: '#ffffff' }
}

export function getSectionNavStyles(
  sectionKey: NavSectionKey,
  isDark = false,
): SectionNavStyles {
  const theme = NAV_SECTION_THEMES[sectionKey]
  return {
    icon: isDark
      ? adaptIconForDark(theme.color)
      : { bg: theme.color, fg: '#ffffff' },
    activeBg: isDark ? theme.activeBgDark : theme.activeBgLight,
    activeBorder: theme.color,
  }
}
